import React from 'react'

const TermsConditionsBannerSection = () => {
    return (
        <>
            <section className="bannerSec innerBanner">
                <div className="box-position" style={{background: 'url("images/innerBanner.jpg")'}}>

                </div>
                <div className="bannerTxt">
                    <h1>Terms & Conditions</h1>
                </div>
            </section>
        </>
    )
}

export default TermsConditionsBannerSection